import * as React from "react";
import { observer } from "mobx-react";
import { useContext } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { Input, Form } from "antd";
import { setInputMode } from "../../services/input";

export const PhoneNumberFormItem = observer(() => {
  const store = useContext(ContactViewStoreContext);

  return (
    <Form.Item label="ご本人様電話番号">
      <Input
        ref={setInputMode("tel")}
        type="tel"
        value={store.phoneNumber}
        onChange={e => {
          store.phoneNumber = e.target.value;
        }}
      />
    </Form.Item>
  );
});
